import { Fragment } from 'react';
import PropTypes from 'prop-types';

import { CollapsibleText } from '@spotahome/ui-library';

import { trans } from '@spotahome/soyuz/client';

import ListingContent from '@spotahome/marketplace-common/src/components/ListingContent';

import ListingTitle from './ListingTitle';

const ListingDescription = ({
  title = undefined,
  description,
  collapsible = false,
  ...restProps
}) => {
  const ContentContainer = collapsible ? CollapsibleText : Fragment;
  return (
    <div {...restProps}>
      {title && <ListingTitle role="secondary">{title}</ListingTitle>}
      <div>
        <ContentContainer
          showMoreText={trans('common.view-more')}
          showLessText={trans('common.view-less')}
        >
          <ListingContent content={description} />
        </ContentContainer>
      </div>
    </div>
  );
};

ListingDescription.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string.isRequired,
  collapsible: PropTypes.bool
};

export default ListingDescription;
